import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import clientConfig from '../../../../config/client-config';
import NavigationList from '../../../../infra/navigation/navigation-list';
import { AppState } from '../../../../infra/store';

export type DesktopSidebarProps = {};

const DesktopSidebar = ({}: DesktopSidebarProps) => {
  const navigate = useNavigate();
  const logo = useSelector((state: AppState) => state.themeReducer.logo);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      {/* Logo Section */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 3,
          px: 2,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
        onClick={() => navigate('/')}
      >
        <img
          src={logo}
          alt={clientConfig.branding.logoAltText}
          style={{
            maxWidth: '200px',
            width: '100%',
            height: 'auto'
          }}
        />
      </Box>

      {/* Navigation List */}
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            width: '6px'
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'action.disabled',
            borderRadius: '3px'
          }
        }}
      >
        <NavigationList />
      </Box>
    </Box>
  );
};

export default DesktopSidebar;
